import React from 'react';
import { IBlockPrresentation} from './IBlocks';
import { GatsbyImage } from "gatsby-plugin-image";
import classnames from 'classnames';
import * as styles from './Presentation.module.scss';

type Props = {
}

export default function Presentation (props: IBlockPrresentation) {
    const { text, images } = props;

    let classes: string = "is-8-desktop";

    if (images.length === 1) {
        classes = "is-half-desktop";
    }


    return (
        <div className="columns is-centered">
            <div className={classnames(["column", classes])}>


                <div className="columns">
                    <div className="column">
                        <GatsbyImage
                            image={images[0].src.childImageSharp.gatsbyImageData}
                            alt={images[0].alt}
                            title={images[0].title ? images[0].title : images[0].alt} />
                        <p className={styles.caption}>
                            {text}
                        </p>
                    </div>
                    {images.length > 1 && <div className="column">
                        
                        {images[1] && <GatsbyImage
                            image={images[1].src.childImageSharp.gatsbyImageData}
                            alt={images[1].alt}
                            title={images[1].title ? images[1].title : images[1].alt} />}
                        
                        {images[2] && <GatsbyImage
                            image={images[2].src.childImageSharp.gatsbyImageData}
                            alt={images[2].alt}
                            title={images[2].title ? images[2].title : images[2].alt} />}
                    </div>}
                </div>

            </div>
        </div>
    );
}